import { useEffect } from 'react';
import { useMount } from 'react-use';

import { type Board } from '@air/api/types';

import { usePrivateFiltersEntitiesDetails } from '~/hooks/filters/usePrivateFiltersEntitiesDetails';
import { useSetFiltersFromContextToRedux } from '~/hooks/filters/useSetFiltersFromContextToRedux';
import { useFiltersModifiedManuallyContext } from '~/providers/FiltersModifiedManuallyProvider';
import { useGetPrivateFilterOptions } from '~/swr-hooks/filters/useGetPrivateFilterOptions';

export const useSetPrivateFiltersFromContextToRedux = (boardId?: Board['id']) => {
  const { getFiltersModifiedManually, setFiltersModifiedManually } = useFiltersModifiedManuallyContext();

  const { data: options } = useGetPrivateFilterOptions(boardId);
  const { data: entities } = usePrivateFiltersEntitiesDetails();

  const { setFiltersFromContextToRedux } = useSetFiltersFromContextToRedux({
    options,
    entities,
  });

  useMount(() => {
    setFiltersModifiedManually(true);
  });

  useEffect(() => {
    if (!!options && !!entities && getFiltersModifiedManually()) {
      setFiltersModifiedManually(false);
      setFiltersFromContextToRedux();
    }
  }, [options, entities, setFiltersFromContextToRedux, getFiltersModifiedManually, setFiltersModifiedManually]);

  return {
    setFiltersFromContextToRedux,
  };
};
